import Vue from 'vue'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import InputSelecionaBanco from 'core/components/InputSelecionaBanco.vue'
import InputSliderStepped from 'core/components/InputSliderStepped.vue'
import ComprovantePagamentoModal from 'core/components/ComprovantePagamentoModal.vue'
import ResumoClienteDadosGerais from 'core/components/ResumoClienteDadosGerais.vue'
import DadosContato from 'core/components/DadosContato.vue'
import DadosEndereco from 'core/components/DadosEndereco.vue'
import DocumentoEdit from 'core/components/DocumentoEdit.vue'
import DocumentoModal from 'core/components/DocumentoModal.vue'
import AgendaParcela from 'core/components/AgendaParcela.vue'

const requireComponent = require.context('/', true, /\.vue$/)

requireComponent.keys().forEach(fileName => {
  if (fileName.indexOf('AppLayout') < 0) {
    const componentConfig = requireComponent(fileName)

    const componentName = upperFirst(
      camelCase(fileName.replace(/^\.\//, '').replace(/\.\w+$/, ''))
    )

    Vue.component(componentName, componentConfig.default || componentConfig)
  }
})

Vue.component('InputSelecionaBanco', InputSelecionaBanco)
Vue.component('InputSliderStepped', InputSliderStepped)
Vue.component('ComprovantePagamentoModal', ComprovantePagamentoModal)
Vue.component('ResumoClienteDadosGerais', ResumoClienteDadosGerais)
Vue.component('DadosContato', DadosContato)
Vue.component('DadosEndereco', DadosEndereco)
Vue.component('DocumentoEdit', DocumentoEdit)
Vue.component('DocumentoModal', DocumentoModal)
Vue.component('AgendaParcela', AgendaParcela)
